import ControlChangeUserEmailModal from "@/control/components/ControlChangeUserEmailModal"
import { GlobalID } from "@/relay/RelayTypes"
import {
  OverridableDiscoButton,
  OverridableDiscoButtonProps,
} from "@disco-ui/button/OverridableDiscoButton"

interface Props extends OverridableDiscoButtonProps {
  userId: GlobalID
  onSubmit?: () => void
}
function ControlChangeUserEmailButton({ userId, children, onSubmit, disabled }: Props) {
  return (
    <OverridableDiscoButton
      variant={"outlined"}
      color={"grey"}
      disabled={disabled}
      modal={({ isOpen, onClose }) => {
        if (!isOpen) return null
        return (
          <ControlChangeUserEmailModal
            isOpen={isOpen}
            onClose={onClose}
            onSubmit={onSubmit}
            userId={userId}
          />
        )
      }}
    >
      {children}
    </OverridableDiscoButton>
  )
}

export default ControlChangeUserEmailButton
